import Api from '@/util/Api'

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új beutaló rögzítése',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="far fa-times-circle"></i> Nem',
                event_name: "customClick",
                class: "btn btn-danger my-custom-class mx-1",
                event_payload: 'referralDisagree'
            },
            {
                btn_text: '<i class="fas fa-check"></i> Igen',
                event_name: "customClick",
                class: "btn btn-success my-custom-class mx-1",
                event_payload: 'referralAgree'
            }
        ],
        specFormActions: [
            {
                btn_text: '<i class="fas fa-check"></i> OK',
                event_name: "customClick",
                class: "btn btn-success my-custom-class mx-1",
                event_payload: 'specReferralAgree'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="far fa-folder-open"></i>',
                title: 'Megtekintés',
                event_name: "customClick",
                class: "btn btn-outline-info",
                event_payload: 'seeRow'
            },
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow',
                additionalButtonVisible: 'interReferralEditButtonVisibility',
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow',
                additionalButtonVisible: 'internalReferralDeleteButtonVisibility',
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        headerFields: [
            {
                name: "doctorId",
                label: "Beutaló orvos",
                formVisible: true,
                formRequired: true,
                formReadOnly: true,
                formSize: 4,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllDoctor,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "treatmentTypeId",
                label: "Kért vizsgálat",
                formRequired: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllTreatmentTypesExtended,
                    formatText: function (val) {
                        return val.name;
                    },
                    formatOption: function (val) {
                        return val.name;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'name',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 4,
                formVisible: true
            },
            {
                name: "imageDiagnosticsDetail",
                label: "Képdiagnosztika részletezése",
                formType: "text",
                formSize: 4,
                formVisible: true,
                formRequired: true
            },
            {
                name: "note",
                label: "Megjegyzés",
                formType: "textarea",
                formSize: 4,
                formVisible: true,
            }
        ],
        searchFields: [
            {
                name: "referralId",
                label: "Beutaló sorszáma",
                formVisible: false
            },
            {
                name: "name",
                label: "Beutaló orvos",
                formVisible: true,
                formSize: 4,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllDoctor,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "vaccine",
                label: "Beutaló orvos szakmája",
                formType: "text",
                formSize: 4,
                formVisible: true
            },
            {
                name: "occupationalIndication",
                label: "Kért vizsgálat",
                formType: "text",
                formSize: 4,
                formVisible: true
            },
            {
                name: "dosage",
                label: "Megjegyzés",
                formType: "text",
                formSize: 4,
                formVisible: true,
            },
            {
                name: "basicImmunization",
                label: "Beutalás ideje",
                formType: "date",
                formSize: 4,
                formVisible: true
            },
            {
                name: "boosterVaccination",
                label: "Felhasználva",
                formType: 'select', 
                formSize: 4,
                formVisible: true,
                selectOptions: {
                    externalOptionList: [
                        {
                            id: "1",
                            text: 'Felhasználás dátuma',
                        },
                        {
                            id: "2",
                            text: 'Nem került felhasználásra',
                        },
                        {
                            id: "3",
                            text: 'Lejárt',
                        }
                    ],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
        ]
    }
}
